/**
 * The app's router: one splat route whose element is the whole app (ADR-0386).
 *
 * The app runs on a data router only so that `useBlocker` works
 * (`routing/useUnsavedChangesGuard.tsx`). Every page still lives in the
 * descendant `<Routes>` of `AppRoutes`; nothing about the route table moved.
 *
 * Load-bearing: this route has no `loader`, `action`, `lazy` or `middleware`,
 * and the options carry no `getContext`, `dataStrategy` or
 * `patchRoutesOnNavigation`. Under those conditions `router.navigate` pushes
 * the history entry synchronously, before its returned promise yields, and
 * `AuthContext.switchAccount` depends on that: it navigates and then sets the
 * new user in the same tick, so no render and no request ever pairs the old
 * account in the URL with the new cookie (ADR-0302, Decision 5). Adding any of
 * the above makes the push asynchronous; `__tests__/appRouter.test.tsx` fails
 * first.
 *
 * Side-effect free, so tests can build the same router without importing the
 * page graph. `main.tsx` creates the browser router from it.
 */

import type { ReactNode } from "react";
import type { RouteObject } from "react-router-dom";

/** Options for `createBrowserRouter`. Deliberately empty; see the header. */
export const appRouterOptions = {};

export function appRoutes(element: ReactNode, errorElement: ReactNode): RouteObject[] {
  return [{ path: "*", element, errorElement }];
}
